export default __webpack_public_path__ + "static/media/media-kit-fr.99d192ff.svg";